export const variableTypes = {
  NUMBER: 'NUMBER',
  PERCENTAGE: 'PERCENTAGE'
}
